/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HealthTab from '../HealthTabV2/HealthTabUpdated/index';
import Assesment from '../HealthTabV2/AssesmentAndCategory/index';
import { setSelectedYear, fetchOverviewTabApi, fetWellbeingCategories, fetchWBAQuestionByCategoryId, fetchWellbeingAssessmentDetails, fetchHealthAndWellbeingAssessmentForFourCard, fetchReportTabAction, getCompanies as getAllCompanies, setCompany, fetchBiometricTabApi,  showBiometricStatus, getTopWellnessInitiatives } from '../../redux/actions';
import { Layout, Main } from '../AdminTeamCreation/styles';
import { ButtonContainer, ConfirmButton, InitiativesContainer, NoData, StyledModal } from './styles'
import { isUndefined } from 'lodash';
import BiometricTab from '../BiometricTab';
import HoverButton from '../common/HoverButton';
import { AddIconBranding, DownloadDocumentIcon, ErrorDocumentUploadIcon, SuccessDocumentUploadIcon, UploadDocumentIcon, closeIcon, ProductTourIcon } from '../../utils/icons';
import { Modal, Spinner } from 'react-bootstrap';
import { Border } from '../EventDetails/styles';
import { t } from 'i18next';
import { fetchApi } from '../../utils/methods';
import { FetchSampleBiometricDoc, UploadBiometricCsvData, GetCompanyBiometricDetails, GetHealthDataSnapshot, GetTopHealthDepartmentAndLocations, GetBestHealthPerformers, GetActiveUpcomingInitiatives } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import CSVList from '../PeopleHomeV2/CSVList';
import CompletedInitiatives from '../EngagementSectionV2/CompanyInitiative/completedInitiatives';
import RecurringInitiatives from '../EngagementSectionV2/CompanyInitiative/recurringInitiatives';
import LibraryInitiative from '../EngagementSectionV2/CompanyInitiative/library'
import SnapShot from '../HealthDataManagement/snapshot'
import { BrandingTab, BrandingTabContainer } from '../common/commonStyles'
import { CommonFilterDropdown } from '../common/CommonYearFilter/CommonYearFilter';
import { BASE_URL } from '../../utils/config';
import { MainContainer, TopContainerWrapper } from '../Recognition/RecognitionActivity/styles';
import { BorderBottom, TabBottomLine, TabWrapper } from '../RecogntionAdmin/styles';
import Walkthrough from './Driver/HDMDriver';

const filterOption = ['Monthly', 'Quarterly', 'Yearly'];
const yearlyOptions = ['2025', '2024', '2023'];

const currentYear = new Date().getFullYear();

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: props.companyInfo.id,
      selectedTabId: 1,
      selectedHealthTabId: 1,
      tabValue: 'overview',
      healthTabValue:
        this.props.history.location.state === 'biometric'
          ? 'biometric'
          : this.props.history.location.state === 'wbareport'
            ? 'wbareport'
            : this.props.history.location.state === 'library'
              ? 'library'
              : 'healthdash',
      isHealthDash: true,
      categoryIdValue: 1,
      menuIsOpen: false,
      companyName: props.companyInfo.name,
      showBulkPopup: false,
      showSuccessPopup: false,
      showErrorPopup: false,
      printSampleBiometricCSV: false,
      printErrorLogCSV: false,
      failedCount: 0,
      successCount: 0,
      spinner: false,
      biometricShowandHideStatus: null,
      filterOptions: filterOption,
      timeInterval: 'Yearly',
      filterOptionsName: yearlyOptions,
      monthInterval: new Date().getFullYear(),
      getSnapShotValue: {},
      getDeptAndLocData: {},
      getBestPerformerMonth: {},
      getBestPerformerQuarter: {},
      bestPerformerPageMonth: 1,
      bestPerformerPageQuarter: 1,
      getBestPerformerMonthUsers: [],
      getBestPerformerQuarterUsers: [],
      getFeatured: [],
      getActive: [],
      getUpcoming: [],
      showWalkthrough: false,
      biometricScreeningPresent: false
    };
    this.dropdownRef = React.createRef();
  }

  onProductTourClick = () => {
    this.manageHealthTabs('healthdash');
    this.setState({ showWalkthrough: true });
  };

  componentDidMount() {
    const { monthInterval } = this.state;
    const { companyInfo, getTopWellnessInitiatives } = this.props;
    document.addEventListener('mousedown', this.handleClickOutside);
    this.fetchSnapshotAPI('year', monthInterval);
    this.fetchBestPerformer(monthInterval);
    let yearArray = [];
    for (let i = currentYear; i >= companyInfo['companyStartDate']; i--) {
      yearArray.push(i);
    }
    if (yearArray?.length > 0) {
      this.setState({
        filterOptionsName: yearArray
      });
    }
    if (companyInfo?.id === 1) {
      this.setState({
        showWalkthrough: this.props.productTourDetails?.product_tour_data?.admin_hdm
      });
    }
    getTopWellnessInitiatives(companyInfo.id, monthInterval);
  }

  componentDidUpdate(prevProps) {
    if (this.props.productTourDetails != prevProps.productTourDetails) {
      this.setState({
        showWalkthrough: this.props.productTourDetails?.product_tour_data?.admin_hdm
      });
    }

    if (this.props.wellnessInitiatives != prevProps.wellnessInitiatives) {
      const biometricScreeningPresent = this.props?.wellnessInitiatives?.some(
        (initiative) =>
          initiative.initiative_name === 'Biometric Screening' &&
          initiative.is_upcoming === 0
      );
      this.setState({ biometricScreeningPresent: biometricScreeningPresent });
    }
  }

  fetchSnapshotAPI = (type, value) => {
    this.fetchHealthDataSnapshot(type, value);
    this.fetchTopHealthDepartmentAndLocations(type, value);
    this.fetchUpcomingActiveFeaturedInitiatives(type, value);
  };

  fetchUpcomingInitiatives = () => {
    this.fetchUpcomingActiveFeaturedInitiatives('year', this.state.monthInterval);
    this.fetchHealthDataSnapshot('year', this.state.monthInterval);
  };

  fetchBestPerformer = (year) => {
    this.fetchBestPerformerQuarter(year, 1, 7);
    this.fetchBestPerformerMonth(year, 1, 7);
  };

  updatePageMonth = (value) => {
    this.setState(
      {
        bestPerformerPageMonth: value
      },
      () => this.fetchBestPerformerMonth(this.state.monthInterval, value, 7)
    );
  };

  updatePageQuarter = (value) => {
    this.setState(
      {
        bestPerformerPageQuarter: value
      },
      () => this.fetchBestPerformerQuarter(this.state.monthInterval, value, 7)
    );
  };

  updateFilter = (value) => {
    this.setState({
      filterOptionsName: value
    });
  };

  fetchHealthDataSnapshot = async (type, value) => {
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    const { companyId } = this.state;
    let url =
      BASE_URL + GetHealthDataSnapshot + '/' + companyId + '/' + type + '/' + value;
    await fetch(url, { method: 'GET', headers: { AUTHTOKEN: AuthToken },credentials:'include',
      withCredentials: true })
      .then((res) => {
        res
          .json()
          .then((data) => {
            this.setState({
              getSnapShotValue: data?.data
            });
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  fetchUpcomingActiveFeaturedInitiatives = async (type, value) => {
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    const { companyId } = this.state;
    let url =
      BASE_URL +
      GetActiveUpcomingInitiatives +
      '/' +
      companyId +
      '/' +
      type +
      '/' +
      value;
    await fetch(url, { method: 'GET', headers: { AUTHTOKEN: AuthToken },credentials:'include',
      withCredentials: true })
      .then((res) => {
        res
          .json()
          .then((data) => {
            this.setState({
              getFeatured: data?.data?.featured_initiatives,
              getActive: data?.data?.active_initiatives,
              getUpcoming: data?.data?.upcoming_initiatives
            });
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  fetchTopHealthDepartmentAndLocations = async (type, value) => {
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    const { companyId } = this.state;
    let url =
      BASE_URL +
      GetTopHealthDepartmentAndLocations +
      '/' +
      companyId +
      '/' +
      type +
      '/' +
      value;
    await fetch(url, { method: 'GET', headers: { AUTHTOKEN: AuthToken },credentials:'include',
      withCredentials: true })
      .then((res) => {
        res
          .json()
          .then((data) => {
            this.setState({
              getDeptAndLocData: data?.data
            });
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  fetchBestPerformerQuarter = async (year, page, limit) => {
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    const { companyId } = this.state;
    let url =
      BASE_URL +
      GetBestHealthPerformers +
      '/' +
      companyId +
      '/quarter/' +
      year +
      '/' +
      page +
      '/' +
      limit;
    await fetch(url, { method: 'GET', headers: { AUTHTOKEN: AuthToken },credentials:'include',
      withCredentials: true })
      .then((res) => {
        res
          .json()
          .then((data) => {
            this.setState({
              getBestPerformerQuarter: data?.data?.current_quarter
            });
            if (page === 1) {
              this.setState({
                getBestPerformerQuarterUsers: data?.data?.current_quarter?.data
              });
            } else {
              this.setState({
                getBestPerformerQuarterUsers: [
                  ...this.state.getBestPerformerQuarterUsers,
                  ...data.data.current_quarter.data
                ]
              });
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  fetchBestPerformerMonth = async (year, page, limit) => {
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    const { companyId } = this.state;
    let url =
      BASE_URL +
      GetBestHealthPerformers +
      '/' +
      companyId +
      '/month' +
      '/' +
      year +
      '/' +
      page +
      '/' +
      limit;
    await fetch(url, { method: 'GET', headers: { AUTHTOKEN: AuthToken },credentials:'include',
      withCredentials: true })
      .then((res) => {
        res
          .json()
          .then((data) => {
            this.setState({
              getBestPerformerMonth: data?.data?.current_month
            });
            if (page === 1) {
              this.setState({
                getBestPerformerMonthUsers: data?.data?.current_month?.data
              });
            } else {
              this.setState({
                getBestPerformerMonthUsers: [
                  ...this.state.getBestPerformerMonthUsers,
                  ...data.data.current_month.data
                ]
              });
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  setPage = (page) => {
    page === 'biometric'
      ? this.setState({ healthTabValue: 'biometric' })
      : page === 'wbareport'
        ? this.setState({ healthTabValue: 'wbareport' })
        : this.setState({ healthTabValue: 'healthdash' });
  };

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ menuIsOpen: false });
    }
  };

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuIsOpen: !prevState.menuIsOpen
    }));
  };
  getMenuItems = () => {
    const { companies } = this.props;
    return companies && companies.map((company) => company.company_name);
  };

  onSelect = (value) => {
    const { companies, setCompany } = this.props;
    const id = companies.filter((company) => company.company_name === value)[0].id;
    const comapanyStartDate = companies.filter(
      (company) => company.company_name === value
    )[0].company_start_date;
    const biometricStatus = companies.filter(
      (company) => company.company_name === value
    )[0].show_biometric;
    setCompany(id, value, comapanyStartDate, biometricStatus);
    this.setState({
      companyId: id
    });
  };

  fetchWBAQuestionAnswers = (companyId, categoryId, year) => {
    const {
      fetchWBAQuestionByCategoryId,
      fetchWellbeingAssessmentDetails,
      fetchHealthAndWellbeingAssessmentForFourCard,
      fetchReportTabAction
    } = this.props;
    fetchWBAQuestionByCategoryId(companyId, categoryId, year);
    fetchWellbeingAssessmentDetails(companyId, year);
    fetchHealthAndWellbeingAssessmentForFourCard(companyId, year);
    fetchReportTabAction(companyId, year);
  };

  assesmentAPI = (year, categoryID) => {
    this.setState(
      {
        categoryIdValue: categoryID
      },
      () => {
        this.updateDropdown(year, categoryID);
      }
    );
  };

  async getCompanyBiometricDetails(companyId, year) {
    const result = await fetchApi(
      `${GetCompanyBiometricDetails}/${companyId}/${year}`,
      'GET'
    );
    this.setState({
      biometricShowandHideStatus: result
    });
  }

  updateDropdown = (year, categoryID) => {
    const {
      fetchReportTabAction,
      fetchOverviewTabApi,
      setSelectedYear,
      fetchBiometricTabApi,
      fetchBiometricStatus,
      getTopWellnessInitiatives
    } = this.props;
    const { companyId, tabValue, categoryIdValue } = this.state;

    fetchBiometricTabApi(companyId, year);
    fetchReportTabAction(companyId, year);
    fetchBiometricStatus(companyId, year);
    getTopWellnessInitiatives(companyId, year);
    this.getCompanyBiometricDetails(companyId, year);
    if (tabValue === 'overview') {
      fetchReportTabAction(companyId, year);
      fetchOverviewTabApi(companyId, year);
    } else {
      if (isUndefined(categoryID)) {
        this.fetchWBAQuestionAnswers(companyId, categoryIdValue, year);
      } else {
        this.fetchWBAQuestionAnswers(companyId, categoryID, year);
      }
    }
    setSelectedYear(year);
  };

  toggleTab = (active) => {
    this.setState({ selectedTabId: active });
  };

  toggleHealthTab = (active) => {
    this.setState({ selectedHealthTabId: active });
  };

  manageTabs = (status) => {
    const { companyId } = this.state;
    const { selectedYearInfo } = this.props;
    this.setState({ tabValue: status });
    if (status === 'assesment') {
      this.fetchWBAQuestionAnswers(companyId, 1, selectedYearInfo);
    }
  };

  manageHealthTabs = (status) => {
    const { companyId, monthInterval } = this.state;
    const { selectedYearInfo, fetchOverviewTabApi, fetWellbeingCategories } =
      this.props;
    if (status === 'healthdash') {
      this.setState({ isHealthDash: true }, () => {
        this.fetchSnapshotAPI('year', monthInterval);
        this.fetchBestPerformer(monthInterval);
      });
    }
    if (status == 'wbareport') {
      fetchOverviewTabApi(companyId, selectedYearInfo);
      fetWellbeingCategories();
    }
    if (status === 'library') {
      this.setState({ isHealthDash: false });
    }
    // completed and recurring fetch inside their components
    this.setState({ healthTabValue: status });
  };

  getCSVHeaders = () => {
    const csvHeaders = [
      { label: 'User Email', key: 'user_email' },
      { label: 'First Name', key: 'fname' },
      { label: 'Last Name', key: 'lname' },
      { label: 'Department', key: 'department' },
      { label: 'Birthday', key: 'birthday' },
      { label: 'Company Name', key: 'company_name' },
      { label: 'Phone', key: 'phone_number' },
      { label: 'City', key: 'city' },
      { label: 'State', key: 'state' },
      { label: 'Address', key: 'address' },
      { label: 'Postal Code', key: 'postal_code' },
      { label: 'Height (6.5)', key: '' },
      { label: 'Weight(70.9) ', key: '' },
      { label: 'Circumference', key: '' },
      { label: 'BMI', key: '' },
      { label: 'Blood Pressure - systolic', key: '' },
      { label: 'Blood Pressure – diastolic', key: '' },
      { label: 'Fasting', key: '' },
      { label: 'Cholestrol Total', key: '' },
      { label: 'Cholesrtol – HDL', key: '' },
      { label: 'Cholestrol – IDL', key: '' },
      { label: 'Triglycerides', key: '' },
      { label: 'Glucose', key: '' }
    ];

    return csvHeaders;
  };

  getErrorLogCSVHeaders = () => {
    const csvHeaders = [
      { label: 'User Email', key: 'user_email' },
      { label: 'First Name', key: 'fname' },
      { label: 'Last Name', key: 'lname' }
    ];

    return csvHeaders;
  };

  printAction = (bool) => {
    this.setState({ printSampleBiometricCSV: bool });
  };

  printErrorLogAction = (bool) => {
    this.setState({ printErrorLogCSV: bool });
  };

  getBiometricSampleReport = async () => {
    const sampleBiometricReport = await fetchApi(
      FetchSampleBiometricDoc + '/' + this.props.companyInfo.id,
      'GET'
    );

    if (sampleBiometricReport.message) {
      toast.error(sampleBiometricReport.message);
      return;
    } else {
      if (sampleBiometricReport.data.length === 0) {
        toast.error('No data found');
        return;
      } else {
        this.setState(
          { sampleBiometricReport: sampleBiometricReport.data },
          () => {
            this.setState({ printSampleBiometricCSV: true });
          }
        );
      }
    }
  };

  validateDocument = (file) => {
    let validTypes = ['csv'];
    let extenstion = file.split('.').pop();
    let isValid = validTypes.includes(extenstion);
    return isValid;
  };

  uploadDocument = (filesArray) => {
    this.setState({ spinner: true });

    if (filesArray?.name) {
      if (this.validateDocument(filesArray?.name)) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(filesArray);
        fileReader.onloadend = () => {
          this.setState({ biometricCsv: fileReader.result }, () => {
            this.showConfirmVisitModal();
          });
        };
      } else {
        toast.error('Invalid file! Please select valid file format');
      }
    }
  };

  showConfirmVisitModal = async () => {
    const payload = {
      biometric_csv: this.state.biometricCsv,
      company_id: this.props.companyInfo.id
    };

    await fetchApi(`${UploadBiometricCsvData}`, 'POST', payload).then((res) => {
      if (res.data.message) {
        toast.error(res.data.message);
        this.setState({ spinner: false });
      } else if (res.data.failed_count === 0) {
        toast.success('Document uploaded successfully');
        this.setState({ successCount: res.data.success_count }, () => {
          this.setState({
            showBulkPopup: false,
            showSuccessPopup: true,
            spinner: false
          });
        });
      } else if (res.data.failed_count > 0) {
        toast.error('Document uploaded successfully but some data is not uploaded');
        this.setState(
          {
            failedCount: res.data.failed_count,
            successCount: res.data.success_count,
            failedData: res.data.failed_data
          },
          () => {
            this.setState({
              showBulkPopup: false,
              showErrorPopup: true,
              spinner: false
            });
          }
        );
      }
      document.getElementById('event-upload-file').value = '';
    });
  };

  hideInitiativeModal = () => {
    this.setState((prev) => ({
      showErrorPopup: !prev.showErrorPopup
    }));
  };

  userInitiativePopup = () => {
    const { showBulkPopup, initiativeData, spinner } = this.state;
    return (
      <StyledModal show={showBulkPopup} width={'400px'} height={'380'}>
        <div className={'modal-container'}>
          <div
            onClick={() => this.setState({ showBulkPopup: false })}
            style={{ margin: '14px 0px 0px -14px', cursor: 'pointer' }}
          >
            {closeIcon()}
          </div>
          <div
            style={{
              color: '#005C87',
              marginTop: '0px',
              textDecoration: 'none',
              fontSize: '18px'
            }}
          >
            {initiativeData.name}
          </div>
        </div>
        <Border
          style={{
            background: 'rgba(0, 92, 135, 0.10)',
            margin: '20px 0px 0px 0px'
          }}
        />
        <Modal.Body>
          <InitiativesContainer>
            <div className={'details'}>{t('Do you want to upload biometric data?')}</div>
            <ButtonContainer>
              <ConfirmButton
                margin="30px auto 5px auto"
                width="352px"
                style={{ background: '#007AB1', position: 'relative' }}
              >
                {spinner ? (
                  <Spinner color="white" />
                ) : (
                  <>
                    {t('Upload Document')}
                    <span style={{ marginLeft: '12px' }}>{UploadDocumentIcon()}</span>
                  </>
                )}
                <input
                  id="event-upload-file"
                  type="file"
                  name="user"
                  accept=".csv"
                  multiple={false}
                  style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    opacity: '0',
                    cursor: 'pointer'
                  }}
                  onChange={(e) =>
                    e.target.files[0] && !spinner && this.uploadDocument(e.target.files[0])
                  }
                />
              </ConfirmButton>
            </ButtonContainer>
            <ButtonContainer>
              <ConfirmButton
                onClick={() => this.getBiometricSampleReport()}
                margin="30px auto 5px auto"
                width="352px"
                style={{
                  background: 'white',
                  border: '1px solid #007AB1',
                  color: '#007AB1'
                }}
              >
                {t('Download Sample Document')}
                <span style={{ marginLeft: '12px' }}>{DownloadDocumentIcon()}</span>
              </ConfirmButton>
            </ButtonContainer>
          </InitiativesContainer>
        </Modal.Body>
      </StyledModal>
    );
  };

  successPopup = () => {
    const { showSuccessPopup, successCount } = this.state;
    return (
      <StyledModal show={showSuccessPopup} width={'400px'} height={'380'}>
        <div className={'modal-container'}>
          <div
            onClick={() => {
              this.setState({ showSuccessPopup: false });
              window.location.reload();
            }}
            style={{ margin: '14px 0px 0px -14px', cursor: 'pointer' }}
          >
            {closeIcon()}
          </div>
          <div
            style={{
              color: '#005C87',
              marginTop: '0px',
              textDecoration: 'none',
              fontSize: '18px'
            }}
          >
            <span style={{ marginRight: '12px' }}>{SuccessDocumentUploadIcon()}</span>
            {'Sucessfully Uploaded'}
          </div>
        </div>
        <Border
          style={{
            background: 'rgba(0, 92, 135, 0.10)',
            margin: '20px 0px 0px 0px'
          }}
        />
        <Modal.Body>
          <InitiativesContainer>
            <div className={'details'}>
              {t(`You successfully uploaded data for ${successCount} users`)}
            </div>
            <ButtonContainer>
              <ConfirmButton
                onClick={() => {
                  this.setState({ showSuccessPopup: false });
                  window.location.reload();
                }}
                margin="30px auto 5px auto"
                width="352px"
                style={{ background: '#007AB1' }}
              >
                {t('Thank You')}
              </ConfirmButton>
            </ButtonContainer>
          </InitiativesContainer>
        </Modal.Body>
      </StyledModal>
    );
  };

  errorPopup = () => {
    const { showErrorPopup, failedCount, successCount } = this.state;
    return (
      <StyledModal show={showErrorPopup} width={'400px'} height={'380'}>
        <div className={'modal-container'}>
          <div
            onClick={() => {
              this.setState({ showErrorPopup: false });
              window.location.reload();
            }}
            style={{ margin: '14px 0px 0px -14px', cursor: 'pointer' }}
          >
            {closeIcon()}
          </div>
          <div
            style={{
              color: '#005C87',
              marginTop: '0px',
              textDecoration: 'none',
              fontSize: '18px',
              alignItems: 'center'
            }}
          >
            <span style={{ marginRight: '12px' }}>{ErrorDocumentUploadIcon()}</span>
            {'Error'}
          </div>
        </div>
        <Border
          style={{
            background: 'rgba(0, 92, 135, 0.10)',
            margin: '20px 0px 0px 0px'
          }}
        />
        <Modal.Body>
          <InitiativesContainer>
            <div className={'details'}>
              <span style={{ width: '84%' }}>
                {t(
                  `You successfully uploaded data for ${successCount} users, but there was an error with the other ${failedCount} users data.`
                )}
                <br /> <br />
                Click the download button to see the errors in the entries.
              </span>
            </div>
            <ButtonContainer>
              <ConfirmButton
                onClick={() => this.setState({ printErrorLogCSV: true })}
                margin="30px auto 5px auto"
                width="352px"
                style={{ background: '#007AB1' }}
              >
                {t('Download File')}
                <span style={{ marginLeft: '12px' }}>
                  {<DownloadDocumentIcon fill={'white'} width={'24px'} height={'25px'} />}
                </span>
              </ConfirmButton>
            </ButtonContainer>
          </InitiativesContainer>
        </Modal.Body>
      </StyledModal>
    );
  };

  setTimeInterval = (value) => {
    this.setState({
      timeInterval: value
    });
  };

  setMonthInterval = (value) => {
    this.setState({
      monthInterval: value
    });
  };

  getCurrentQuarter = () => {
    const month = new Date().getMonth(); // Get 1-based month (1 = Jan, 2 = Feb, ...)
    if (month >= 1 && month <= 3) return 0;
    if (month >= 4 && month <= 6) return 1;
    if (month >= 7 && month <= 9) return 2;
    return 3; // Months 10-12
  };

  handleTimeIntervalChange = (selectedOption) => {
    const { companyInfo } = this.props;
    const currentYear = new Date().getFullYear();
    let yearArray = [];
    for (let i = currentYear; i >= companyInfo['companyStartDate']; i--) {
      yearArray.push(i);
    }
    this.setTimeInterval(selectedOption);
    this.setMonthInterval(currentYear);
    this.updateFilter(yearArray);
    this.fetchSnapshotAPI('year', currentYear);
  };

  handleMonthNameChange = (selectedOption) => {
    this.setMonthInterval(selectedOption);
    if (this.state.healthTabValue === 'healthdash') {
      this.fetchSnapshotAPI('year', selectedOption);
      this.fetchBestPerformer(selectedOption);
    }
  };

  hideProductTour = () => {
    this.setState({ showWalkthrough: false });
  };

  render() {
    const {
      selectedYearInfo,
      assesmentDetails,
      healthWellbeingCardData,
      wellnessWins,
      addressableHealthRisk,
      reportMessage,
      showReportTab,
      wellbeingCategoriesData,
      WbaQuestionData,
      healthImprovementOpportunities,
      companies,
      companyInfo,
      setCompany,
      role,
      history
    } = this.props;
    const {
      tabValue,
      companyId,
      companyName,
      healthTabValue,
      showBulkPopup,
      printSampleBiometricCSV,
      sampleBiometricReport,
      showSuccessPopup,
      showErrorPopup,
      failedData,
      printErrorLogCSV,
      timeInterval,
      monthInterval,
      filterOptionsName,
      getSnapShotValue,
      getDeptAndLocData,
      getBestPerformerMonth,
      getBestPerformerQuarter,
      bestPerformerPageMonth,
      bestPerformerPageQuarter,
      getBestPerformerMonthUsers,
      getBestPerformerQuarterUsers,
      getFeatured,
      getActive,
      getUpcoming,
      biometricScreeningPresent
    } = this.state;
    const currentYear = new Date().getFullYear();
    let yearArray = [];
    for (let i = currentYear; i >= companyInfo['companyStartDate']; i--) {
      yearArray.push(i);
    }
    let showHideCustomize = false;
    if (timeInterval === 'Yearly' && monthInterval === currentYear) {
      showHideCustomize = true;
    }
    let getColor = '#DA6C74';

    return (
      <Layout>
        <Main>
          {
            <BrandingTabContainer
              marginBottom="25px"
              marginRight="0px"
              isCompare="auto 0 auto auto"
              style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 10px' }}
            >
              {this.state.showWalkthrough && (
                <Walkthrough
                  manageHealthTabs={this.manageHealthTabs}
                  companyId={companyInfo?.id}
                  showWalkthrough={this.state.showWalkthrough}
                  hideProductTour={this.hideProductTour}
                />
              )}
              <div style={{ display: 'flex' }}>
                <BrandingTab
                  id="hdm-snapshot"
                  width
                  padding
                  active={healthTabValue === 'healthdash'}
                  background={getColor ? getColor : '#0b4170'}
                  onClick={() => this.manageHealthTabs('healthdash')}
                >
                  Dashboard
                </BrandingTab>
                <BrandingTab
                  id="hdm-wba-report"
                  width
                  padding
                  active={healthTabValue === 'wbareport'}
                  background={getColor ? getColor : '#0b4170'}
                  onClick={() => this.manageHealthTabs('wbareport')}
                >
                  WBA Reports
                </BrandingTab>
                <BrandingTab
                  id="hdm-biometric"
                  width
                  padding
                  active={healthTabValue === 'biometric'}
                  background={getColor ? getColor : '#0b4170'}
                  onClick={healthTabValue == 'biometric' ? null : () => this.manageHealthTabs('biometric')}
                >
                  Biometrics
                </BrandingTab>
                <BrandingTab
                  id="hdm-completed"
                  width
                  padding
                  active={healthTabValue === 'completed'}
                  background={getColor ? getColor : '#0b4170'}
                  onClick={healthTabValue == 'completed' ? null : () => this.manageHealthTabs('completed')}
                >
                  Completed
                </BrandingTab>

                {/* New Recurring Tab (same like Completed) */}
                <BrandingTab
                  id="hdm-recurring"
                  width
                  padding
                  active={healthTabValue === 'recurring'}
                  background={getColor ? getColor : '#0b4170'}
                  onClick={healthTabValue == 'recurring' ? null : () => this.manageHealthTabs('recurring')}
                >
                  Recurring
                </BrandingTab>

                <BrandingTab
                  id="hdm-library"
                  width
                  padding
                  active={healthTabValue === 'library'}
                  background={getColor ? getColor : '#0b4170'}
                  onClick={healthTabValue == 'library' ? null : () => this.manageHealthTabs('library')}
                >
                  Library
                </BrandingTab>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {companyInfo?.id === 1 ? (
                    <div className="compare">
                      <HoverButton
                        title={'Product tour'}
                        svgPath={<ProductTourIcon />}
                        activeColor={'#F37A65'}
                        inActiveColor={'#F37A65'}
                        backgroundColor={'white'}
                        backgroundColorActive={'#F37A65'}
                        onClick={this.onProductTourClick}
                        width={'24px'}
                        height={'24px'}
                        fillOpacity={1}
                      />
                    </div>
                  ) : null}
                  {healthTabValue === 'biometric' && biometricScreeningPresent ? (
                    <div style={{ marginRight: '6px' }}>
                      <HoverButton
                        fillOpacity={1}
                        svgPath={<UploadDocumentIcon fill={'#F37A65'} width={'24px'} height={'25px'} />}
                        activeColor={'#F37A65'}
                        inActiveColor={'#F37A65'}
                        backgroundColor={'white'}
                        backgroundColorActive={'#F37A65'}
                        width={'24px'}
                        height={'25px'}
                        title={'Bulk Upload'}
                        onClick={() =>
                          biometricScreeningPresent &&
                          this.setState({ showBulkPopup: true, initiativeData: { name: 'Bulk Upload' } })
                        }
                        disabled={!biometricScreeningPresent}
                      />
                    </div>
                  ) : null}

                  {healthTabValue === 'biometric' || healthTabValue === 'wbareport' ? (
                    <>
                      <CommonFilterDropdown
                        options={filterOptionsName?.slice(0, 3)}
                        selectedOption={selectedYearInfo}
                        setSelectedOption={this.updateDropdown}
                        dropdownHeight={'auto'}
                        customStyles={{ marginLeft: '10px' }}
                      />
                    </>
                  ) : null}

                  {(healthTabValue === 'healthdash' ||
                    healthTabValue === 'completed' ||
                    healthTabValue === 'recurring') && (
                    <div className="rightSection" style={{ display: 'flex' }}>
                      <div id="hdm-year-dropdown" style={{ marginLeft: '10px', display: 'flex' }}>
                        <CommonFilterDropdown
                          options={filterOptionsName?.slice(0, 3)}
                          selectedOption={monthInterval}
                          setSelectedOption={this.handleMonthNameChange}
                          dropdownHeight={'auto'}
                        />
                      </div>
                    </div>
                  )}

                  {healthTabValue === 'library' ? (
                    <div className="compare" id="hdm-create-initiative">
                      <HoverButton
                        title={'Create HDM Initiative'}
                        svgPath={<AddIconBranding />}
                        activeColor={'#F37A65'}
                        inActiveColor={'#F37A65'}
                        backgroundColor={'white'}
                        backgroundColorActive={'#F37A65'}
                        onClick={() => history.push('/company/health-initiatve/create')}
                        width={'24px'}
                        height={'24px'}
                        fillOpacity={1}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </BrandingTabContainer>
          }
          {healthTabValue === 'healthdash' && (
            <>
              <SnapShot
                companyId={companyInfo?.id}
                history={history}
                getSnapShotValue={getSnapShotValue}
                getDeptAndLocData={getDeptAndLocData}
                getBestPerformerMonth={getBestPerformerMonth}
                getBestPerformerQuarter={getBestPerformerQuarter}
                updatePageMonth={this.updatePageMonth}
                updatePageQuarter={this.updatePageQuarter}
                bestPerformerPageMonth={bestPerformerPageMonth}
                bestPerformerPageQuarter={bestPerformerPageQuarter}
                getBestPerformerMonthUsers={getBestPerformerMonthUsers}
                getBestPerformerQuarterUsers={getBestPerformerQuarterUsers}
                manageHealthTabs={this.manageHealthTabs}
                showHideCustomize={showHideCustomize}
                getFeatured={getFeatured}
                getActive={getActive}
                getUpcoming={getUpcoming}
                selectedYear={monthInterval}
                fetchUpcomingInitiatives={this.fetchUpcomingInitiatives}
              />
            </>
          )}
          {healthTabValue === 'wbareport' && (
            <>
              {
                <>
                  <MainContainer margin>
                    <TopContainerWrapper style={{ flexWrap: 'wrap' }}>
                      <TabWrapper>
                        <TabBottomLine
                          id="hdm-wba-overviewtab"
                          active={tabValue == 'overview'}
                          background={getColor ? getColor : '#0b4170'}
                          onClick={() => this.manageTabs('overview')}
                        >
                          Overview
                          <BorderBottom
                            active={tabValue == 'overview'}
                            background={getColor ? getColor : '#0b4170'}
                          />
                        </TabBottomLine>
                        <TabBottomLine
                          id="hdm-wba-assessmenttab"
                          active={tabValue == 'assesment'}
                          background={getColor ? getColor : '#0b4170'}
                          onClick={tabValue == 'assesment' ? null : () => this.manageTabs('assesment')}
                        >
                          Assessment
                          <BorderBottom
                            active={tabValue == 'assesment'}
                            background={getColor ? getColor : '#0b4170'}
                          />
                        </TabBottomLine>
                      </TabWrapper>
                    </TopContainerWrapper>
                  </MainContainer>
                </>
              }
              {!showReportTab ? (
                <NoData>
                  {reportMessage ? `${reportMessage}` : null}
                  <br />
                  Minimum 10 users should have completed the HRA to view the aggregate health
                  reports
                </NoData>
              ) : tabValue == 'overview' ? (
                <HealthTab
                  assesmentDetails={assesmentDetails}
                  healthWellbeingCardData={healthWellbeingCardData}
                  wellnessWins={wellnessWins}
                  addressableHealthRisk={addressableHealthRisk}
                  healthImprovementOpportunities={healthImprovementOpportunities}
                  companyName={companyName}
                />
              ) : (
                <Assesment
                  wellbeingCategoriesData={wellbeingCategoriesData}
                  companyId={companyId}
                  selectedYearInfo={selectedYearInfo}
                  assesmentAPI={this.assesmentAPI}
                  WbaQuestionData={WbaQuestionData}
                  healthWellbeingCardData={healthWellbeingCardData}
                  assesmentDetails={assesmentDetails}
                />
              )}
            </>
          )}
          {healthTabValue === 'biometric' && (
            <>
              <BiometricTab
                companies={companies}
                companyInfo={companyInfo}
                setCompany={setCompany}
                role={role}
                yearList={yearArray}
                selectedYearInfo={selectedYearInfo}
                biometricShowandHideStatus={this.state.biometricShowandHideStatus}
                showWalkthrough={this.state.showWalkthrough}
              />
            </>
          )}
          {healthTabValue === 'completed' && (
            <>
              <CompletedInitiatives
                companies={companies}
                companyInfo={companyInfo}
                setCompany={setCompany}
                role={role}
                yearList={yearArray}
                selectedYearInfo={selectedYearInfo}
                location={this.props.history.location}
                isHealthDash={this.state.isHealthDash}
                history={this.props.history}
                tabSwitch={this.props.history.location.state}
                isLibrary={true}
                setPage={this.setPage}
                selectedYear={monthInterval}
              />
            </>
          )}
          {healthTabValue === 'recurring' && (
            <>
              <RecurringInitiatives
                companies={companies}
                companyInfo={companyInfo}
                setCompany={setCompany}
                role={role}
                yearList={yearArray}
                selectedYearInfo={selectedYearInfo}
                location={this.props.history.location}
                isHealthDash={this.state.isHealthDash}
                history={this.props.history}
                tabSwitch={this.props.history.location.state}
                isLibrary={true}
                setPage={this.setPage}
                selectedYear={monthInterval}
              />
            </>
          )}
          {healthTabValue === 'library' && (
            <>
              <LibraryInitiative
                selectedYearInfo={selectedYearInfo}
                companyInfo={companyInfo}
                history={this.props.history}
                companyId={this.props.companyId}
              />
            </>
          )}
        </Main>

        {showBulkPopup && this.userInitiativePopup()}
        {showSuccessPopup && this.successPopup()}
        {showErrorPopup && this.errorPopup()}
        {printSampleBiometricCSV && (
          <CSVList
            Title={`${'Sample Biometric'}`}
            removeCSVData={this.printAction}
            headers={this.getCSVHeaders()}
            data={sampleBiometricReport}
          />
        )}
        {printErrorLogCSV && (
          <CSVList
            Title={`${'Biometric Error Logs'}`}
            removeCSVData={this.printErrorLogAction}
            headers={this.getErrorLogCSVHeaders()}
            data={failedData}
          />
        )}
      </Layout>
    );
  }
}
Reports.defaultProps = {
  companyInfo: { id: 1, name: '', showBiometricStatus: 1 }
};

Reports.propTypes = {
  companies: PropTypes.array,
  companyInfo: PropTypes.object.isRequired,
  setCompany: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  history: PropTypes.object,
  showReportTab: PropTypes.bool,
  selectedYearInfo: PropTypes.number,
  yearList: PropTypes.array,
  setSelectedYear: PropTypes.func,
  showCompaniesDropdown: PropTypes.bool,
  fetchOverviewTabApi: PropTypes.func,
  assesmentDetails: PropTypes.array,
  healthWellbeingCardData: PropTypes.array,
  wellnessWins: PropTypes.array,
  addressableHealthRisk: PropTypes.array,
  reportMessage: PropTypes.string,
  fetWellbeingCategories: PropTypes.func,
  wellbeingCategoriesData: PropTypes.array,
  fetchWBAQuestionByCategoryId: PropTypes.func,
  WbaQuestionData: PropTypes.array,
  fetchHealthAndWellbeingAssessmentForFourCard: PropTypes.func,
  fetchWellbeingAssessmentDetails: PropTypes.func,
  fetchReportTabAction: PropTypes.func,
  healthImprovementOpportunities: PropTypes.array,
  fetchBiometricTabApi: PropTypes.func,
  fetchBiometricStatus: PropTypes.func,
  t: PropTypes.func,
  wellnessInitiatives: PropTypes.array,
  companyId: PropTypes.number,
  companyInfoData: PropTypes.object,
  productTourDetails: PropTypes.object,
  getTopWellnessInitiatives: PropTypes.func
};

const mapStateToProps = (state) => ({
  selectedYearInfo: state.companyDashboard.selectedYearInfo,
  assesmentDetails: state.adminReports.assesmentDetails,
  healthWellbeingCardData: state.adminReports.healthWellbeingCardData,
  wellnessWins: state.adminReports.wellnessWins,
  addressableHealthRisk: state.adminReports.addressableHealthRisk,
  reportMessage: state.companyDashboard.reportMessage,
  showReportTab: state.companyDashboard.showReportTab,
  wellbeingCategoriesData: state.adminReports.wellbeingCategoriesData,
  WbaQuestionData: state.adminReports.WbaQuestionData,
  healthImprovementOpportunities: state.adminReports.healthImprovementOpportunities,
  companies: state.companyDashboard.companies,
  wellnessInitiatives: state.companyDashboard.wellnessInitiatives,
  companyInfoData: state.companyDashboard.companyInfoData,
  productTourDetails: state.profileData.productTourDetails
});

const mapDispatchToProps = (dispatch) => ({
  fetchBiometricTabApi: (companyId, year) =>
    dispatch(fetchBiometricTabApi(companyId, year)),
  setSelectedYear: (year) => dispatch(setSelectedYear(year)),
  fetchOverviewTabApi: (id, year) => dispatch(fetchOverviewTabApi(id, year)),
  fetWellbeingCategories: () => dispatch(fetWellbeingCategories()),
  fetchWBAQuestionByCategoryId: (companyId, categoryId, year) =>
    dispatch(fetchWBAQuestionByCategoryId(companyId, categoryId, year)),
  fetchWellbeingAssessmentDetails: (id, year) =>
    dispatch(fetchWellbeingAssessmentDetails(id, year)),
  fetchHealthAndWellbeingAssessmentForFourCard: (id, year) =>
    dispatch(fetchHealthAndWellbeingAssessmentForFourCard(id, year)),
  fetchReportTabAction: (id, year) => dispatch(fetchReportTabAction(id, year)),
  setCompany: (id, name, companyStartDate, biometricStatus) =>
    dispatch(setCompany(id, name, companyStartDate, biometricStatus)),
  fetchAllCompanies: (year) => dispatch(getAllCompanies(year)),
  fetchBiometricStatus: (id, year) => dispatch(showBiometricStatus(id, year)),
  getTopWellnessInitiatives: (companyId, year) =>
    dispatch(getTopWellnessInitiatives(companyId, year))
});

export default connect(mapStateToProps, mapDispatchToProps)(Reports);